/**
 * @see https://nodejs.org/api/os.html#os_os_arch
 * @public
 */
export const getOSArch = () => window["todesktop"].os.arch;
/**
 * @see https://nodejs.org/api/os.html#os_os_platform
 * @public
 */
export const getOSPlatform = () => window["todesktop"].os.platform;
/**
 * @see https://nodejs.org/api/os.html#os_os_release
 * @public
 */
export const getOSRelease = () => window["todesktop"].os.release;
/**
 * @see https://nodejs.org/api/os.html#os_os_type
 * @public
 */
export const getOSType = () => window["todesktop"].os.type;
/**
 * Open a specified URL using the operating system's default URI handling
 * system.
 *
 * **Note:** Due to sandboxing restrictions, the only supported schemes are
 * `http` and `https`. Attempting to open any other URL scheme will result
 * in the `Promise` rejecting.
 *
 * @example Opening Google in the user's default browser
 * ```typescript
 * import { platform } from "@todesktop/client-core";
 *
 * async function init() {
 *   const url = "https://google.com";
 *   await platform.os.openURL(url);
 *   console.log(`Successfully asked the OS to open URL ${url}`);
 * }
 *
 * init()
 * ```
 * @public
 */
export async function openURL(url) {
    return window["todesktop"].contents.openUrlInBrowser(url);
}
